import { createLazyComponent } from 'helpers/createLazyComponent'

const CourseSettingsLazy = createLazyComponent(() => import('./CourseSettings'))

export default CourseSettingsLazy
